export default "__VITE_ASSET__Dp0bje7P__"